export default __webpack_public_path__ + "e896da3c69a950ff9a2707ffea1099ab.png";